import { Skeleton } from "@/components/ui/baseUi/skeleton"
import { cn } from "@/modules/lib/utils"
import { ProgramBundleEntity } from "@modules/programBundle/entities/programBundleEntity"
import { UserProgramDetailsEntity } from "@modules/programs/entities/userProgramDetailsEntity"
import { ProgramSubscriberDetailsContentSkeleton } from "@modules/programs/programSubscriber/components/programSubscriberDetails/progamSubscriberDetailsContentSkeleton"
import { ProgramSubscriberDetailsHeaderWrapper } from "@modules/programs/programSubscriber/components/programSubscriberDetails/programSubscriberDetailsHeaderWrapper"
import { ProgramSubscriberDetailsWrapper } from "@modules/programs/programSubscriber/components/programSubscriberDetails/programSubscriberDetailsWrapper"
import { HuAvatarCardSidebarSkeleton } from "@modules/ui/components/huAvatarCardSidebarSkeleton"
import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"
import { ErrorView } from "@/components/ui/layout/error/errorView"

type ProgramSubscriberDetailsLayoutProps = {
  program: UserProgramDetailsEntity | ProgramBundleEntity
  subscriberId: string
  isBoxSubscriber: boolean
  className?: string
} & React.ComponentProps<"div">

export function ProgramSubscriberDetailsLayout({
  program,
  subscriberId,
  isBoxSubscriber,
  className,
  ...props
}: ProgramSubscriberDetailsLayoutProps) {
  return (
    <ErrorBoundary fallback={<ErrorView />}>
      {/* HEADER */}
      <div className={cn("flex h-full flex-col gap-4", className)} {...props}>
        <Suspense
          fallback={
            <HuAvatarCardSidebarSkeleton
              topContent={
                <div className="flex flex-col items-center gap-1 pt-2">
                  <Skeleton className="h-6 w-21 rounded-md" />
                  <Skeleton className="h-4 w-25 rounded-sm" />
                </div>
              }
            />
          }
        >
          <ProgramSubscriberDetailsHeaderWrapper
            program={program}
            subscriberId={subscriberId}
            isBoxSubscriber={isBoxSubscriber}
          />
        </Suspense>

        {/* CONTENT */}
        <Suspense fallback={<ProgramSubscriberDetailsContentSkeleton />}>
          <ProgramSubscriberDetailsWrapper
            program={program}
            subscriberId={subscriberId}
            isBoxSubscriber={isBoxSubscriber}
          />
        </Suspense>
      </div>
    </ErrorBoundary>
  )
}
